module.exports = __webpack_public_path__ + "static/media/chart.bb4a728c.svg";